export const colorScheme = {
    red: "#D72600",
    green: "#379711",
    blue: "#0956BF",
    yellow: "#ECD407",
    black: "#000000"
}


export const isValid = (playingCard, currentCard) => {

  // console.log(playingCard, currentCard, "New Playing and Current Card");

  if(playingCard.type === "number" && currentCard.type === "number") {
    if(playingCard.display_text === currentCard.display_text) {
      return true;
    } else if(playingCard.color === currentCard.color) {
      return true;
    }
  }

  if(playingCard.color === currentCard.color) {
    return true;
  }

  if(playingCard.display_text === currentCard.display_text) {
    return true;
  }

  if(playingCard.type === "power") {
    return true;
  }

  return false;

}

export function encrypt(text) {
  let encryptedText = '';
  for (let i = 0; i < text.length; i++) {
    if (i % 2 === 0) {
      encryptedText += String.fromCharCode(text.charCodeAt(i) + 5);
    } else {
      encryptedText += String.fromCharCode(text.charCodeAt(i) - 7);
    }
  }
  return encryptedText;
}

export function decrypt(encryptedText) {
  let decryptedText = '';
  for (let i = 0; i < encryptedText.length; i++) {
    if (i % 2 === 0) {
      decryptedText += String.fromCharCode(encryptedText.charCodeAt(i) - 5);
    } else {
      decryptedText += String.fromCharCode(encryptedText.charCodeAt(i) + 7);
    }
  }
  return decryptedText;
}

export const getInviteLink = (roomNo) => {

  const url = new URL(window.location.href);
const domain = url.origin;

  const urlWithQueryParam = domain + `?inviteQ=${roomNo}`;

  console.log("Invite URL= ", urlWithQueryParam);
  navigator.clipboard.writeText(urlWithQueryParam)
  // console.log(encryptedData, decrypt(encryptedData));
  // console.log(decryptedData.split(separator));

}